module.exports = __webpack_public_path__ + "fonts/xjAJXh38I15wypJXxuGMBvZraR2Tg8w2lzm7kLNL0-w.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/xjAJXh38I15wypJXxuGMBvZraR2Tg8w2lzm7kLNL0-w.woff2
// module id = 406
// module chunks = 0